<template>
    <div>

        <div class="col-md-12" v-if="viewno == 0">
            <div class="row">
                <div class="col-md-6">
                    <h3 class="page-header" style="margin-bottom: 0px;">
                        <i class="fa fa-building-o animated bounceInDown show-info"></i>

                        <span>Furniture List</span>
                    </h3>
                </div>
                <div class="col-md-6 text-end">
                    <button class="btn btn-primary mt-20" @click="refresh()">Refresh</button>
                </div>
            </div>
            <div class="col-md-12 table-responsive" style="padding:0px;">
                <div class="panel">
                    <div class="panel-body table" style="overflow-x:auto;padding-left:0px">
                        <table class="table table-bordered table-font"
                            style="margin-bottom:0;font-size:15px!important;">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Product Name</th>
                                    <th>Sub-Category</th>
                                    <th>Company</th>
                                    <th>Product Price</th>
                                    <th>Youtube Link</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in products" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.category.name }}</td>
                                    <td>
                                         <div v-for="attr in item.attribute" v-bind:key="attr.id" :attr="attr">
                                            {{ getcompany(attr.attribute_value_ids) }}
                                        </div>
                                    </td>
                                    <td>{{ item.cp }}</td>
                                    <td>{{ item.videourl }}</td>
                                    <td>
                                        <button class="btn btn-primary-edit btn-active" @click="edit(item)">
                                            <i class="fa fa-edit"></i></button>
                                        <button class="btn btn-primary-print btn-active ml-5" @click="uploadImg(item)">
                                            <i class="fa fa-upload"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-12" style="margin-top: 20px">
                <nav aria-label="Page navigation example" style="text-align: right !important">
                    <paginate style="margin: 0px !important; float: right" :page-count="noofpages"
                        :click-handler="clickCallback" :prev-text="'&laquo;'" :next-text="'&raquo;'"
                        :container-class="'pagination'">
                    </paginate>
                </nav>
            </div>
        </div>
        <div v-if="viewno == 1">
            <furniture-form :editfurniture="this.editfurniture" @close="this.cancel"></furniture-form>
        </div>
        <div v-if="viewno == 2">
            <upload-images :furniture="this.editfurniture" @close="this.cancel"></upload-images>
        </div>
        
    </div>
</template>
<script>
import Paginate from "vuejs-paginate";
import { mapGetters } from 'vuex'
import FurnitureForm from "./FurnitureForm.vue";
import Constants from "../../components/utilities/Constants.vue";
import UploadImages from "../upload/UploadImages.vue";
import axios from "axios";

export default {
    mixins: [Constants],
    components: { Paginate, FurnitureForm, UploadImages },
    data() {
        return {
            currentpage: 1,
            noofrec: 10,
            count: 0,
            viewno: 0,
            editfurniture: null,
            products: [],
            category: null,
            
        }
    },
    computed: {
        ...mapGetters([
            'furniturecategory' , 'attributes'
        ]),
        noofpages() {
            return Math.ceil(parseInt(this.count) / parseInt(this.noofrec))
        }

    },
    mounted() {
        this.$store.dispatch('fetchattributes')
        if(this.furniturecategory == null) {
            this.$store.dispatch('fetchFurnitureCategory');
        }else {
            this.category = this.furniturecategory;
        }
        
            
        this.initialize()
    },
    watch:{
        furniturecategory: function(newVal) {
            if (newVal != null) {
                this.category = newVal;
            }
        },
    },
    methods: {
        initialize() {
            setTimeout(() => {
                this.refresh();
            }, 1000);
        },  
        clickCallback(currentpage) {
            this.currentpage = currentpage
            this.refresh();
        },
        uploadImg(item) {
            this.viewno = 2
            this.editfurniture = item    
        },
        refresh(){
            axios.post('api/products/furniture', {
                page: this.currentpage,
                noofrec: this.noofrec,
                // categoryids: this.category?.id,
                categoryid: [this.category?.id],
                // searchtext: this.searchtext,
                // storeid: this.selectedstoreid,
                // brandid: this.brandid,  
                // categoryid: this.categoryid,
            })
            .then((response) => {
                this.count = response.data.count;
                this.products = response.data.products;
            })
            .catch((error) => {
                console.log(error);
            });
        },
        edit(item) {
            this.viewno = 1
            this.editfurniture = item
        },
        cancel() {
            this.viewno = 0
            this.editfurniture = null
            this.refresh()
        },
        getcompany(attribute_value_ids) {
            let brand = this.attributes.find((block) => block.id == 2);
            console.log("brand", brand)
            if (typeof brand !== "undefined") {
                let companyname = brand.predefinedvalues.find( a=> a.id == attribute_value_ids);
                console.log(companyname)
                if (typeof companyname != "undefined") {
                    return companyname.value;
                }
            }
            return attribute_value_ids;
        },

    },
}
</script>
<style >
    .btn-active {
        font-size: 18px !important;
        padding: 0px 8px !important;
        color:#fff !important;
    }
</style>
